import type { EvalueeStatus } from "../lib/types";

const STATUS_CLASS: Record<EvalueeStatus, string> = {
  未着手: "status-badge status-badge--not-started",
  一時保存: "status-badge status-badge--draft",
  完了: "status-badge status-badge--done",
};

export default function StatusBadge({ status }: { status: EvalueeStatus }) {
  return <span className={STATUS_CLASS[status]}>{status}</span>;
}
